exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectAddToBasket{border:1px solid silver;border-radius:6px;padding:10px;width:100%}.soldOut{background:red;color:#fff;padding:6px 10px 4px;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58cfaa31","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/AddToBasket.vue
// module id = KaSZ
// module chunks = 116